import { AnnotationsPermission } from '@/pages/ControlSheet/ui/ControlSheetPage'
import { ControlSheetTrip } from '../../types/types'
import { TripTooltip } from '../../ui/TripTooltip'

export const runTripTooltip = (trip: ControlSheetTrip, mealRelief?: boolean) => (
    <TripTooltip
        tripNumber={trip.trip}
        isNearDrivingHours={trip.isNearDrivingHours}
        plannedTime={trip?.departStandTime ?? ''}
        departingDepot={trip.depotGarage ?? ''}
        notes={[]}
        previous={
            mealRelief
                ? {
                      trip: trip.nextTripForDuty ?? '',
                      run: 'Unknown',
                      lateMealReliefMayAffect: trip.lateMealReliefMayAffect,
                  }
                : undefined
        }
    />
)

export const runTripTooltipMealRelief = (trip: ControlSheetTrip, annotationsPermission: AnnotationsPermission) => {
    const prev = {
        trip: trip.nextTripForDuty ?? '',
        run: 'Unknown',
        lateMealReliefMayAffect: trip.lateMealReliefMayAffect,
    }

    return (
        <TripTooltip
            tripNumber={trip.trip}
            previous={prev}
            notes={trip.annotations.flatMap((a) => a.notes)}
            annotationsPermission={annotationsPermission}
        />
    )
}
